import React from 'react'
import Dropzone from 'react-dropzone'

class FileInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { preview: null }
    this.onChange = this.onChange.bind(this)
  }

  onChange(files) {
    // For Redux form
    if (this.props.input) {
      const {input: {onChange}} = this.props
      onChange(files[0])
    }
    else if(this.props.onChange){
    	this.props.onChange(files[0])
    }
    else{
    	console.warn('redux-form-dropzone => Forgot to pass onChange props ?');
    }

    if (files[0]) this.setState({ preview: files[0].preview })
  }

  render() {
    const { preview } = this.state
    const {accept, className, multiple } = this.props
    let dropzoneRef

    return (
      <div className="row"> 
        <div className="small-12 medium-6 medium-centered column">
        <Dropzone 
          {...this.props}
          ref={(node) => { dropzoneRef = node; }}
          onDrop={ this.onChange } 
          accept={accept} 
          className={className} 
          multiple={multiple} >
          <div className="fa fa-file-image-o"></div>
          <p>Drag a file here or click to upload.</p>
          { preview && <img src={ preview } alt="" /> }
        </Dropzone>
        </div>

        <div className="row">
            <div className="small-12 medium-6 medium-centered column">
              <button className="button primary upload-image-btn expanded" 
              onClick={(e) => { e.preventDefault(); dropzoneRef.open() }}>UPLOAD/CAPTURE IMAGE</button>
            </div>
        </div>

      </div>
    )
  }
}
export default FileInput


// WEBPACK FOOTER //
// ./src/components/FileInput.js